import type { ConnectOptions } from './connect'
import { hideModal, activeModalStack, showModal, miscUiState } from './globalState'
import { appStatusState, resetAppStatusState } from './react/AppStatusProvider'

let ourLastStatus: string | undefined = ''
// Minimum time the splash stays visible so the metallic stripe animation
// and caption have time to read, even if loading finishes instantly.
const MIN_SPLASH_MS = 2000
let splashShownAt = 0
let pendingHideTimer: ReturnType<typeof setTimeout> | null = null

export const setLoadingScreenStatus = function (status: string | undefined | null, isError = false, hideDots = false, fromFlyingSquid = false, minecraftJsonMessage?: Record<string, any>) {
  if (typeof status === 'string') status = window.translateText?.(status) ?? status
  // null can come from flying squid, should restore our last status
  if (status === null) {
    status = ourLastStatus
  } else if (!fromFlyingSquid) {
    ourLastStatus = status
  }
  fromFlyingSquid = false

  if (status === undefined) {
    // Defer the hide if the splash hasn't been visible for MIN_SPLASH_MS.
    // This guarantees the stripe animation and caption are seen even on
    // fast loads (e.g. small replays that finish in <1s).
    if (splashShownAt && performance.now() - splashShownAt < MIN_SPLASH_MS) {
      if (pendingHideTimer) clearTimeout(pendingHideTimer)
      const elapsed = performance.now() - splashShownAt
      const remaining = Math.max(0, MIN_SPLASH_MS - elapsed)
      pendingHideTimer = setTimeout(() => {
        pendingHideTimer = null
        splashShownAt = 0
        appStatusState.status = ''
        hideModal({ reactType: 'app-status' }, {}, { force: true })
      }, remaining)
      return
    }
    if (pendingHideTimer) {
      clearTimeout(pendingHideTimer)
      pendingHideTimer = null
    }
    splashShownAt = 0
    appStatusState.status = ''

    hideModal({ reactType: 'app-status' }, {}, { force: true })
    return
  }

  if (!activeModalStack.some(x => x.reactType === 'app-status')) {
    // just showing app status
    resetAppStatusState()
    splashShownAt = performance.now()
  }
  showModal({ reactType: 'app-status' })
  if (appStatusState.isError) {
    return
  }
  appStatusState.hideDots = hideDots
  appStatusState.isError = isError
  appStatusState.lastStatus = isError ? appStatusState.status : ''
  appStatusState.status = status
  appStatusState.minecraftJsonMessage = minecraftJsonMessage ?? null

  if (isError && miscUiState.gameLoaded) {
    void import('./browserfs').then(({ resetStateAfterDisconnect }) => {
      resetStateAfterDisconnect()
    })
  }
}
globalThis.setLoadingScreenStatus = setLoadingScreenStatus

export const lastConnectOptions = {
  value: null as ConnectOptions | null,
  hadWorldLoaded: false
}
globalThis.lastConnectOptions = lastConnectOptions
